<template>
    <div class="card">
        <div class="card-header">
            {{partner.name}}
        </div>
        <div class="card-body">
            <address>
                {{partner.street}}
                <br/>{{partner.postcode}} {{partner.place}}
                <br/>{{partner.country}}
                <br/>
                <br/>Tel.: {{partner.telephone}}
                <a v-if="!!partner.homepage" :href="partner.homepage"><br/>{{partner.homepage}}</a>
            </address>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'partner'
        ]
    }
</script>

<style scoped>

</style>
